module.exports = __webpack_public_path__ + "img/download-icon.b342cdff.svg";